import SharedOperationLogs from "../../shared/OperationLogs"

function OperationLogs({ logs, clearLogs }) {
  return <SharedOperationLogs logs={logs} onClear={clearLogs} />
}

export default OperationLogs
